/*
 * @Author: cmchiu
 * @Date: 2022-04-28 11:10:35
 * @LastEditTime: 2023-01-12 09:29:47
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \LearningMarket2\LearningMarket-ClientApp\src\store\modules\app.js
 *
 */
const state = {
    keyword: '',
    stid: '',
    pnTitle: '',
    reload: false,
}

const mutations = {
    SET_KEYWORD: (state, keyword) => {
        state.keyword = keyword
    },

    SET_STID: (state, stid) => {
        state.stid = stid
    },

    SET_PNTITLE: (state, pnTitle) => {
        state.pnTitle = pnTitle
    },

    SET_RELOAD: (state, reload) => {
        state.reload = reload
    },
}

const actions = {
    cacheKeyword({ commit }, keyword) {
        commit('SET_KEYWORD', keyword)
    },

    cacheSTID({ commit }, stid) {
        commit('SET_STID', stid)
    },

    cachePNTitle({ commit }, pnTitle) {
        commit('SET_PNTITLE', pnTitle)
    },

    reloadComponents({ commit }, reload) {
        commit('SET_RELOAD', reload)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
